import loadable from '@loadable/component';

// 懒加载组件
const EsmdInventoryQuery = loadable(() => import('./EsmdInventoryQuery'));

export const subRoutes = [
  {
    path: '/EsmdInventoryQuery',
    component: EsmdInventoryQuery
  }
];
